import React, { useState } from 'react'
import { bool, object, func } from 'prop-types'
import Dater from '../../../../services/DateFormat'
import { Button } from '@mui/material'
import { Jasper } from '../../../../services/http'
import { BaseDatePicker } from '../../../../components/shared'
import GestaoOpenButton from './GestaoOpenButton'
import BasicModal from '../../../../components/shared/modals/BaseModal'
import { saveLog } from '../../../../utils/SaveLog'
ModalProcessar.propTypes = {
  status: bool,
  setStatus: func,
  query: object
}
export default function ModalProcessar({ status, setStatus }) {
  const [currentYear, setCurrentYear] = useState(
    Dater().formatar(new Date(), 'yyyy')
  )
  const [currentMonth, setCurrentMonth] = useState(
    parseInt(Dater().formatar(new Date(), 'mm'))
  )
  // const [currentYear, setCurrentYear] = useState(
  //   Dater().formatar(new Date(), 'yyyy')
  // )
  // const [currentMonth, setCurrentMonth] = useState(
  //   parseInt(Dater().formatar(new Date(), 'mm'))
  // )

  const formatMesAno = value => {
    let { $M } = value
    const { $y } = value
    $M = $M + 1
    setMesAno(value)
    setCurrentYear($y)
    setCurrentMonth($M)
  }

  const [mesAno, setMesAno] = useState(new Date())

  return (
    <BasicModal
      title="Processar Relatório"
      Caller={GestaoOpenButton}
      status={status}
      closeEvent={event => {
        setStatus(event)
      }}
      sx={{
        minWidth: '22vw',
        width: { xs: '100vw', md: '32vw', xl: '22vw' }
      }}
    >
      <form>
        <BaseDatePicker
          minDate={
            parseInt(Dater().formatar(new Date(), 'yyyy')) - 1 + '-01-01'
          }
          maxDate={Dater().formatar(new Date(), 'yyyy-mm') + '-31'}
          value={mesAno}
          onChange={formatMesAno}
          label="Mês/Ano"
          inputFormat="MM/YYYY"
          mask="__/____"
          openTo="month"
          views={['year', 'month']}
        />
        <Button
          type="button"
          onClick={() => {
            Jasper().ProcessaLeituras().store(
              { mes: currentMonth, ano: currentYear },
              {
                notification: true,
                message: 'Sucesso ao processar relatório!'
              }
            )

            saveLog(
              `Processou o relatório de leituras do mês ${currentMonth}/${currentYear}`
            )
            setTimeout(() => {
              setStatus(false)
            }, 500)
          }}
          style={{ marginTop: '1rem' }}
          variant="contained"
        >
          Processar
        </Button>
      </form>
    </BasicModal>
  )
}
